import React, { useEffect, useMemo, useState } from "react";

import { cloneDeep } from "lodash";

import { ReactComponent as Search } from "../../build/images/teams/search-normal.svg";
import { ReactComponent as CampaignIcon } from "../../build/images/campaignSideContent/campaign-icon.svg";
import { ReactComponent as ArrowIcon } from "../../build/images/campaignSideContent/arrow-left.svg";
import { ReactComponent as ShareIcon } from "../../build/images/campaignSideContent/plane-icon.svg";
import { ReactComponent as EmptyState } from "../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as PdfIcon } from "../../build/images/helpSideContent/pdf-attachment.svg";
import { ReactComponent as ZipIcon } from "../../build/images/helpSideContent/zip-attachment.svg";
import { ReactComponent as XlsIcon } from "../../build/images/helpSideContent/xls-attachment.svg";
import { ReactComponent as XlsxIcon } from "../../build/images/helpSideContent/xlsx-attachment.svg";
import { ReactComponent as DocxIcon } from "../../build/images/helpSideContent/docx-attachment.svg";
import { ReactComponent as DocIcon } from "../../build/images/helpSideContent/doc-attachment.svg";
import { ReactComponent as PptIcon } from "../../build/images/helpSideContent/ppt-attachment.svg";
import { ReactComponent as PptxIcon } from "../../build/images/helpSideContent/pptx-attachment.svg";
import { ReactComponent as TxtIcon } from "../../build/images/helpSideContent/txt-attachment.svg";

import "./help-side-content.css";
import {
  listHelpSideContentStepFour,
  listHelpSideContentStepOne,
  listHelpSideContentStepThree,
  listHelpSideContentStepTwo,
} from "../../actions";
import urlIngWeb from "../../actions/urlIngWeb";
import ModalImage from "../ModalImage";
import Audio from "../Audio/Audio";
import SkeletonLoading from "../SkeletonLoading";
import { useDispatch, useSelector } from "react-redux";
import { changeMessageFromHelpSideContent } from "../../actions/changeMessageFromHelpSideContent";
import { changeIsLoadingSideContent } from "../../actions/changeIsLoadingSideContent";
import { CircularProgress, Tooltip } from "@mui/material";
import { useFilesToNotSend } from "../../hooks/useFilesToNotSend";
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";
import { connection_platform } from "../../services/api";
import { useFilesToSend } from "../../hooks/useFilesToSend";
import { toast } from "react-toastify";

const HelpSideContent = ({ isToShare = true }) => {
  const contactId = useSelector((state) => state.atendimento);
  const infoUsers = useSelector((state) => state.informationusers);
  const isSendingMessage = useSelector((state) => state.isLoadingSideContent);
  const ingFaqConditions = useSelector((state) => state.ingFaqConditions);
  const dispatch = useDispatch();

  const [pageSelected, setPageSelected] = useState(0);
  const [openGallery, setOpenGallery] = useState(false);
  const [galeryContent, setGaleryContent] = useState([]);
  const [linkImg, setLinkImg] = useState("");
  const [messagesToSend, setMessagesToSend] = useState([]);

  const [inputValue, setInputValue] = useState("");
  const [dataStepOne, setDataStepOne] = useState([]);
  const [textToFilterStepOne, setTextToFilterStepOne] = useState("");
  const filteredDataStepOne = useMemo(() => {
    const isTextToFilterStepOneBlank = textToFilterStepOne === "";
    if (isTextToFilterStepOneBlank) {
      return dataStepOne;
    }
    const hasDataStepOne =
      !!dataStepOne && Array.isArray(dataStepOne) && dataStepOne.length > 0;
    if (!hasDataStepOne) {
      return [];
    }

    return dataStepOne.filter((stepOneItem) => {
      return stepOneItem.title
        .toLowerCase()
        .includes(textToFilterStepOne.toLowerCase());
    });
  }, [textToFilterStepOne, dataStepOne]);
  const [isLoadingStepOne, setIsLoadingStepOne] = useState(false);

  const [dataStepTwo, setDataStepTwo] = useState([]);
  const [isLoadingStepTwo, setIsLoadingStepTwo] = useState(false);
  const [textToFilterStepTwo, setTextToFilterStepTwo] = useState("");
  const [inputValueStepTwo, setInputValueStepTwo] = useState("");
  const [titleOfStepTwo, setTitleOfStepTwo] = useState(null);
  const filteredDataStepTwo = useMemo(() => {
    const isTextToFilterStepTwoBlank = textToFilterStepTwo === "";
    if (isTextToFilterStepTwoBlank) {
      return dataStepTwo;
    }

    const hasDataStepTwo =
      !!dataStepTwo && Array.isArray(dataStepTwo) && dataStepTwo.length > 0;
    if (!hasDataStepTwo) {
      return [];
    }

    return dataStepTwo.filter((stepTwoItem) => {
      return stepTwoItem.title
        .toLowerCase()
        .includes(textToFilterStepTwo.toLowerCase());
    });
  }, [textToFilterStepTwo, dataStepTwo]);

  const [dataStepThree, setDataStepThree] = useState([]);
  const [isLoadingStepThree, setIsLoadingStepThree] = useState(false);
  const [textToFilterStepThree, setTextToFilterStepThree] = useState("");
  const [inputValueStepThree, setInputValueStepThree] = useState("");
  const [titleOfStepThree, setTitleOfStepThree] = useState(null);
  const filteredDataStepThree = useMemo(() => {
    const isTextToFilterStepThreeBlank = textToFilterStepThree === "";
    if (isTextToFilterStepThreeBlank) {
      return dataStepThree;
    }

    const hasDataStepThree =
      !!dataStepThree &&
      Array.isArray(dataStepThree) &&
      dataStepThree.length > 0;
    if (!hasDataStepThree) {
      return [];
    }

    return dataStepThree.filter((stepThreeItem) => {
      const hasDescConteudo = !!stepThreeItem.desc_conteudo;
      const hasThisTextOnDescConteudo =
        hasDescConteudo &&
        typeof stepThreeItem.desc_conteudo === "string" &&
        stepThreeItem.desc_conteudo
          .toLowerCase()
          .includes(textToFilterStepThree.toLowerCase());

      const hasTitle = !!stepThreeItem.title;
      const hasThisTextOnTitle =
        hasTitle &&
        typeof stepThreeItem.title === "string" &&
        stepThreeItem.title
          .toLowerCase()
          .includes(textToFilterStepThree.toLowerCase());

      return hasThisTextOnTitle || hasThisTextOnDescConteudo;
    });
  }, [textToFilterStepThree, dataStepThree]);

  const [dataStepFour, setDataStepFour] = useState([]);
  const [isLoadingStepFour, setIsLoadingStepFour] = useState(false);
  const [textToFilterStepFour, setTextToFilterStepFour] = useState("");
  const [inputValueStepFour, setInputValueStepFour] = useState("");
  const [titleOfStepFour, setTitleOfStepFour] = useState(null);
  const filteredDataStepFour = useMemo(() => {
    const isTextToFilterStepFourBlank = textToFilterStepFour === "";
    if (isTextToFilterStepFourBlank) {
      return dataStepFour;
    }

    const hasDataStepFour =
      !!dataStepFour && Array.isArray(dataStepFour) && dataStepFour.length > 0;
    if (!hasDataStepFour) {
      return [];
    }

    return dataStepFour.filter((stepFourItem) => {
      const hasTreatedText = !!stepFourItem.treatedText;
      if (hasTreatedText) {
        return stepFourItem.treatedText
          .toLowerCase()
          .includes(textToFilterStepFour.toLowerCase());
      } else {
        return false;
      }
    });
  }, [textToFilterStepFour, dataStepFour]);

  const { filesToNotSend, clearFilesToNotSend, handleCheckToRemoveFiles } =
    useFilesToNotSend();

  const { fileToSend, clearFilesToSend, handleCheckToAddFiles } =
    useFilesToSend();

  const disabledButton = useMemo(() => {
    if (connection_platform.allowSendingMultipleItemInCampaing) {
      const messagesToSend = Array.isArray(filteredDataStepFour)
        ? filteredDataStepFour.filter(
            (data) => !filesToNotSend.includes(data.id_conteudo)
          )
        : [];
      return isSendingMessage || messagesToSend.length === 0;
    } else {
      const messagesToSend = Array.isArray(filteredDataStepFour)
        ? filteredDataStepFour.filter((data) => fileToSend === data.id_conteudo)
        : [];
      return isSendingMessage || messagesToSend.length === 0;
    }
  }, [isSendingMessage, filteredDataStepFour, fileToSend, filesToNotSend]);

  const hasFilteredDataStepOne =
    !!filteredDataStepOne &&
    Array.isArray(filteredDataStepOne) &&
    filteredDataStepOne.length > 0;

  const hasFilteredDataStepTwo =
    !!filteredDataStepTwo &&
    Array.isArray(filteredDataStepTwo) &&
    filteredDataStepTwo.length > 0;

  const hasFilteredDataStepThree =
    !!filteredDataStepThree &&
    Array.isArray(filteredDataStepThree) &&
    filteredDataStepThree.length > 0;

  const hasFilteredDataStepFour =
    !!filteredDataStepFour &&
    Array.isArray(filteredDataStepFour) &&
    filteredDataStepFour.length > 0;

  /*
function sendMessage(type, message) {
const isOnlyText = type === "text";
if (isOnlyText) {
const callid = makeid(32);
const isMessageEmpty = message.replace(/\s/g, "") === "";
if (!isMessageEmpty) {
let formatedMessage = message.trim();
formatedMessage = formatedMessage.replace(/(?:\r\n|\r|\n)/gm, "\\n");
formatedMessage = formatedMessage.replace(/"/gm, '\\"');

inviteMessage(
callid,
formatedMessage,
"Me",
infoUsers,
contactId,
"0",
formatedMessage,
"url",
false,
[],
0,
undefined,
undefined,
[],
"hsm§"
);
}

if (mensagemretorno[contactId.idatendimento] != true) {
dispatch(refreshReturnAtd(1, contactId.telefone));
mensagemretorno[contactId.idatendimento] = true;
}

if (mensagemenviada[contactId.idatendimento] != true) {
dispatch(editAtendimentoAgent(contactId.idatendimento));
mensagemenviada[contactId.idatendimento] = true;
}
}
}
*/
  const listContentStepTwoDirect = async (idcategoria) => {
    setIsLoadingStepOne(true);
    setIsLoadingStepTwo(true);
    setIsLoadingStepThree(true);
    let updatedDataStepTwo = [];
    let updatedTitleOfStepTwo = null;
    const response = await listHelpSideContentStepTwo(
      idcategoria,
      1,
      ingFaqConditions.url
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && Array.isArray(data) && data.length > 0;
      if (hasData) {
        updatedDataStepTwo = data.map((datum) => {
          datum.title = datum.desc_secao;
          return datum;
        });
        updatedTitleOfStepTwo = {
          name: data[0].desc_categoria,
          id: data[0].id_categoria,
          active: false,
        };
      }
    }
    setTitleOfStepTwo(updatedTitleOfStepTwo);
    setDataStepTwo(updatedDataStepTwo);

    const hasOnlyOneDataInStepTwo = updatedDataStepTwo.length === 1;
    if (hasOnlyOneDataInStepTwo) {
      let updatedDataStepThree = [];
      let updatedTitleOfStepThree = null;
      const id_secao = updatedDataStepTwo[0].id_secao;

      const response = await listHelpSideContentStepThree(
        id_secao,
        1,
        ingFaqConditions.url
      );
      const hasResponse = !!response;
      if (hasResponse) {
        const data = response.data;
        const hasData = !!data && data.length > 0;
        if (hasData) {
          updatedDataStepThree = data.map((datum) => {
            datum.title = datum.desc_assunto;
            return datum;
          });
          updatedTitleOfStepThree = {
            name: data[0].desc_secao,
            id: data[0].id_secao,
            active: false,
          };
        }
      }
      setTitleOfStepThree(updatedTitleOfStepThree);
      setDataStepThree(updatedDataStepThree);

      const hasOnlyOneStepThree = updatedDataStepThree.length === 1;
      if (hasOnlyOneStepThree) {
        let updatedDataStepFour = [];
        let updatedTitleOfStepFour = null;
        const id_assunto = updatedDataStepThree[0].id_assunto;

        const response = await listHelpSideContentStepFour(
          id_assunto,
          1,
          ingFaqConditions.url
        );
        const hasResponse = !!response && response.status === 200;
        if (hasResponse) {
          const data = response.data;
          const hasData = !!data && data.length > 0;
          if (hasData) {
            updatedDataStepFour = data.map((datum) => {
              const descContent = datum.desc_conteudo;
              const hasDescContent = !!descContent;
              const hasLink =
                !!datum.caminho_arquivo &&
                datum.caminho_arquivo !== "null" &&
                datum.caminho_arquivo !== "undefined" &&
                datum.caminho_arquivo !== "null.undefined" &&
                datum.caminho_arquivo !== ".undefined" &&
                datum.typename !== "message";

              if (hasDescContent && !hasLink) {
                datum.typeOfContent = "onlyText";
                datum.linkOfFile = "";
                datum.treatedText = datum.desc_conteudo
                  .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                  .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                  .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                  .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                  .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                  .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                  .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                  .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                  .replace(/&amp;/g, "&") // Substitui "&" codificados
                  .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                  .trim();
              }

              if (hasDescContent && hasLink) {
                datum.typeOfContent = "textAndFile";
                datum.linkOfFile = datum.caminho_arquivo;
                datum.treatedText = datum.desc_conteudo
                  .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                  .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                  .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                  .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                  .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                  .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                  .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                  .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                  .replace(/&amp;/g, "&") // Substitui "&" codificados
                  .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                  .trim();
              }

              if (!hasDescContent && hasLink) {
                datum.typeOfContent = "onlyFile";
                datum.linkOfFile = datum.caminho_arquivo;
                datum.treatedText = "";
              }

              const hasInternalLink =
                hasDescContent &&
                typeof datum.desc_conteudo === "string" &&
                datum.desc_conteudo.includes("</a>") &&
                Boolean(datum.desc_conteudo.match(/href="([^"]+)"/));
              if (hasInternalLink) {
                const hrefMatch = datum.desc_conteudo.match(/href="([^"]+)"/);
                datum.typeOfContent = "externalLink";
                datum.linkOfFile = "";
                datum.treatedText = datum.desc_conteudo
                  .replace(/<a\b[^>]*href="([^"]*)"[^>]*>.*?<\/a>/gi, "$1")
                  .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                  .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                  .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                  .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                  .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                  .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                  .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                  .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                  .replace(/&amp;/g, "&") // Substitui "&" codificados
                  .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                  .trim();
              }

              const hasYoutubeLink =
                hasDescContent &&
                typeof datum.desc_conteudo === "string" &&
                datum.desc_conteudo.includes("</iframe>") &&
                Boolean(datum.desc_conteudo.match(/src="([^"]+)"/));

              if (hasYoutubeLink) {
                const hrefMatch = datum.desc_conteudo.match(/src="([^"]+)"/);
                datum.typeOfContent = "externalLink";
                datum.linkOfFile = "";
                datum.treatedText = datum.desc_conteudo
                  .replace(
                    /<iframe\b[^>]*src="([^"]*)"[^>]*>.*?<\/iframe>/gi,
                    "$1"
                  )
                  .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                  .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                  .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                  .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                  .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                  .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                  .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                  .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                  .replace(/&amp;/g, "&") // Substitui "&" codificados
                  .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                  .trim();
              }

              if (
                !hasDescContent &&
                !hasLink &&
                !hasInternalLink &&
                !hasYoutubeLink
              ) {
                datum.typeOfContent = "";
                datum.linkOfFile = "";
                datum.treatedText = "";
              }

              datum.title = datum.desc_assunto;
              return datum;
            });

            updatedTitleOfStepFour = {
              name: data[0].desc_assunto,
              id: data[0].id_assunto,
              active: false,
            };
          }
        }
        setTitleOfStepFour(updatedTitleOfStepFour);
        setDataStepFour(updatedDataStepFour);

        setPageSelected(3);
        clearFilesToNotSend();
        clearFilesToSend();
      } else {
        setPageSelected(2);
        clearFilesToNotSend();
        clearFilesToSend();
      }
    } else {
      setPageSelected(1);
      clearFilesToNotSend();
      clearFilesToSend();
    }

    setIsLoadingStepOne(false);
    setIsLoadingStepTwo(false);
    setIsLoadingStepThree(false);
  };

  const listContentStepTwo = async (idcategoria) => {
    setIsLoadingStepTwo(true);
    let updatedDataStepTwo = [];
    let updatedTitleOfStepTwo = null;
    const response = await listHelpSideContentStepTwo(
      idcategoria,
      1,
      ingFaqConditions.url
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && Array.isArray(data) && data.length > 0;
      if (hasData) {
        updatedDataStepTwo = data.map((datum) => {
          datum.title = datum.desc_secao;
          return datum;
        });
        updatedTitleOfStepTwo = {
          name: data[0].desc_categoria,
          id: data[0].id_categoria,
          active: false,
        };
      }
    }
    setTitleOfStepTwo(updatedTitleOfStepTwo);
    setDataStepTwo(updatedDataStepTwo);
    setIsLoadingStepTwo(false);
  };

  const listContentStepThreeDirect = async (idsecao) => {
    setIsLoadingStepOne(true);
    setIsLoadingStepTwo(true);
    setIsLoadingStepThree(true);
    setIsLoadingStepFour(true);
    let updatedDataStepThree = [];
    let updatedTitleOfStepThree = null;
    let updatedTitleOfStepTwo = cloneDeep(titleOfStepTwo);
    updatedTitleOfStepTwo.active = true;
    const response = await listHelpSideContentStepThree(
      idsecao,
      1,
      ingFaqConditions.url
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && Array.isArray(data) && data.length > 0;
      if (hasData) {
        updatedDataStepThree = data.map((datum) => {
          datum.title = datum.desc_assunto;
          return datum;
        });
        updatedTitleOfStepThree = {
          name: data[0].desc_secao,
          id: data[0].id_secao,
          active: false,
        };
      }
    }

    setTitleOfStepTwo(updatedTitleOfStepTwo);
    setTitleOfStepThree(updatedTitleOfStepThree);
    setDataStepThree(updatedDataStepThree);

    const hasOnlyOneStepThree = updatedDataStepThree.length === 1;

    if (hasOnlyOneStepThree) {
      let updatedDataStepFour = [];
      let updatedTitleOfStepFour = null;
      const id_assunto = updatedDataStepThree[0].id_assunto;

      const response = await listHelpSideContentStepFour(
        id_assunto,
        1,
        ingFaqConditions.url
      );
      const hasResponse = !!response && response.status === 200;
      if (hasResponse) {
        const data = response.data;
        const hasData = !!data && data.length > 0;
        if (hasData) {
          updatedDataStepFour = data.map((datum) => {
            const descContent = datum.desc_conteudo;
            const hasDescContent = !!descContent;
            const hasLink =
              !!datum.caminho_arquivo &&
              datum.caminho_arquivo !== "null" &&
              datum.caminho_arquivo !== "undefined" &&
              datum.caminho_arquivo !== "null.undefined" &&
              datum.caminho_arquivo !== ".undefined" &&
              datum.typename !== "message";

            if (hasDescContent && !hasLink) {
              datum.typeOfContent = "onlyText";
              datum.linkOfFile = "";
              datum.treatedText = datum.desc_conteudo
                .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                .replace(/&amp;/g, "&") // Substitui "&" codificados
                .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                .trim();
            }

            if (hasDescContent && hasLink) {
              datum.typeOfContent = "textAndFile";
              datum.linkOfFile = datum.caminho_arquivo;
              datum.treatedText = datum.desc_conteudo
                .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                .replace(/&amp;/g, "&") // Substitui "&" codificados
                .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                .trim();
            }

            if (!hasDescContent && hasLink) {
              datum.typeOfContent = "onlyFile";
              datum.linkOfFile = datum.caminho_arquivo;
              datum.treatedText = "";
            }

            const hasInternalLink =
              hasDescContent &&
              typeof datum.desc_conteudo === "string" &&
              datum.desc_conteudo.includes("</a>") &&
              Boolean(datum.desc_conteudo.match(/href="([^"]+)"/));
            if (hasInternalLink) {
              const hrefMatch = datum.desc_conteudo.match(/href="([^"]+)"/);
              datum.typeOfContent = "externalLink";
              datum.linkOfFile = "";
              datum.treatedText = datum.desc_conteudo
                .replace(/<a\b[^>]*href="([^"]*)"[^>]*>.*?<\/a>/gi, "$1")
                .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                .replace(/&amp;/g, "&") // Substitui "&" codificados
                .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                .trim();
            }

            const hasYoutubeLink =
              hasDescContent &&
              typeof datum.desc_conteudo === "string" &&
              datum.desc_conteudo.includes("</iframe>") &&
              Boolean(datum.desc_conteudo.match(/src="([^"]+)"/));

            if (hasYoutubeLink) {
              const hrefMatch = datum.desc_conteudo.match(/src="([^"]+)"/);
              datum.typeOfContent = "externalLink";
              datum.linkOfFile = "";
              datum.treatedText = datum.desc_conteudo
                .replace(
                  /<iframe\b[^>]*src="([^"]*)"[^>]*>.*?<\/iframe>/gi,
                  "$1"
                )
                .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                .replace(/&amp;/g, "&") // Substitui "&" codificados
                .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                .trim();
            }

            if (
              !hasDescContent &&
              !hasLink &&
              !hasInternalLink &&
              !hasYoutubeLink
            ) {
              datum.typeOfContent = "";
              datum.linkOfFile = "";
              datum.treatedText = "";
            }

            datum.title = datum.desc_assunto;
            return datum;
          });

          updatedTitleOfStepFour = {
            name: data[0].desc_assunto,
            id: data[0].id_assunto,
            active: false,
          };
        }
      }
      setTitleOfStepFour(updatedTitleOfStepFour);
      setDataStepFour(updatedDataStepFour);

      setPageSelected(3);
      clearFilesToNotSend();
      clearFilesToSend();
    } else {
      setPageSelected(2);
      clearFilesToNotSend();
      clearFilesToSend();
    }

    setIsLoadingStepOne(false);
    setIsLoadingStepTwo(false);
    setIsLoadingStepThree(false);
    setIsLoadingStepFour(false);
  };

  const listContentStepThree = async (idsecao) => {
    setIsLoadingStepThree(true);
    let updatedDataStepThree = [];
    let updatedTitleOfStepThree = null;
    let updatedTitleOfStepTwo = cloneDeep(titleOfStepTwo);
    updatedTitleOfStepTwo.active = true;
    const response = await listHelpSideContentStepThree(
      idsecao,
      1,
      ingFaqConditions.url
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && Array.isArray(data) && data.length > 0;
      if (hasData) {
        updatedDataStepThree = data.map((datum) => {
          datum.title = datum.desc_assunto;
          return datum;
        });
        updatedTitleOfStepThree = {
          name: data[0].desc_secao,
          id: data[0].id_secao,
          active: false,
        };
      }
    }

    setTitleOfStepTwo(updatedTitleOfStepTwo);
    setTitleOfStepThree(updatedTitleOfStepThree);
    setDataStepThree(updatedDataStepThree);
    setIsLoadingStepThree(false);
  };

  const listContentStepFour = async (idassunto) => {
    setIsLoadingStepFour(true);
    let updatedDataStepFour = [];
    let updatedTitleOfStepFour = null;
    let updatedTitleOfStepThree = cloneDeep(titleOfStepThree);
    updatedTitleOfStepThree.active = true;
    const response = await listHelpSideContentStepFour(
      idassunto,
      1,
      ingFaqConditions.url
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && Array.isArray(data) && data.length > 0;
      if (hasData) {
        updatedDataStepFour = data.map((datum) => {
          const descContent = datum.desc_conteudo;
          const hasDescContent = !!descContent;
          const hasLink =
            !!datum.caminho_arquivo &&
            datum.caminho_arquivo !== "null" &&
            datum.caminho_arquivo !== "undefined" &&
            datum.caminho_arquivo !== "null.undefined" &&
            datum.caminho_arquivo !== ".undefined" &&
            datum.typename !== "message";

          if (hasDescContent && !hasLink) {
            datum.typeOfContent = "onlyText";
            datum.linkOfFile = "";
            datum.treatedText = datum.desc_conteudo
              .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
              .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
              .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
              .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
              .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
              .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
              .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
              .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
              .replace(/&amp;/g, "&") // Substitui "&" codificados
              .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
              .trim();
          }

          if (hasDescContent && hasLink) {
            datum.typeOfContent = "textAndFile";
            datum.linkOfFile = datum.caminho_arquivo;
            datum.treatedText = datum.desc_conteudo
              .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
              .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
              .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
              .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
              .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
              .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
              .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
              .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
              .replace(/&amp;/g, "&") // Substitui "&" codificados
              .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
              .trim();
          }

          if (!hasDescContent && hasLink) {
            datum.typeOfContent = "onlyFile";
            datum.linkOfFile = datum.caminho_arquivo;
            datum.treatedText = "";
          }

          const hasInternalLink =
            hasDescContent &&
            typeof datum.desc_conteudo === "string" &&
            datum.desc_conteudo.includes("</a>") &&
            Boolean(datum.desc_conteudo.match(/href="([^"]+)"/));
          if (hasInternalLink) {
            const hrefMatch = datum.desc_conteudo.match(/href="([^"]+)"/);
            datum.typeOfContent = "externalLink";
            datum.linkOfFile = "";
            datum.treatedText = datum.desc_conteudo
              .replace(/<a\b[^>]*href="([^"]*)"[^>]*>.*?<\/a>/gi, "$1")
              .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
              .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
              .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
              .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
              .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
              .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
              .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
              .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
              .replace(/&amp;/g, "&") // Substitui "&" codificados
              .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
              .trim();
          }

          const hasYoutubeLink =
            hasDescContent &&
            typeof datum.desc_conteudo === "string" &&
            datum.desc_conteudo.includes("</iframe>") &&
            Boolean(datum.desc_conteudo.match(/src="([^"]+)"/));

          if (hasYoutubeLink) {
            const hrefMatch = datum.desc_conteudo.match(/src="([^"]+)"/);
            datum.typeOfContent = "externalLink";
            datum.linkOfFile = "";
            datum.treatedText = datum.desc_conteudo
              .replace(/<iframe\b[^>]*src="([^"]*)"[^>]*>.*?<\/iframe>/gi, "$1")
              .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
              .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
              .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
              .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
              .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
              .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
              .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
              .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
              .replace(/&amp;/g, "&") // Substitui "&" codificados
              .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
              .trim();
          }

          if (
            !hasDescContent &&
            !hasLink &&
            !hasInternalLink &&
            !hasYoutubeLink
          ) {
            datum.typeOfContent = "";
            datum.linkOfFile = "";
            datum.treatedText = "";
          }

          datum.title = datum.desc_assunto;
          return datum;
        });

        updatedTitleOfStepFour = {
          name: data[0].desc_assunto,
          id: data[0].id_assunto,
          active: false,
        };
      }
    }

    setTitleOfStepThree(updatedTitleOfStepThree);
    setTitleOfStepFour(updatedTitleOfStepFour);
    setDataStepFour(updatedDataStepFour);
    setIsLoadingStepFour(false);
  };

  const HtmlContent = ({ htmlString }) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  const renderFileLink = (icon, link, fileName) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          cursor: "pointer",
          backgroundColor: "#e5e5e5",
          padding: "5px 10px",
          borderRadius: 4,
          width: "100%",
        }}
        onClick={() => window.open(link, "_blank")}
      >
        {icon}
        <div>{fileName.length > 16 ? fileName.slice(-16) : fileName}</div>
      </div>
    );
  };

  const treatMimetype = (mimetypeid, typename, link, fileName = "") => {
    const hasLink = !!link && typeof link === "string";
    const hasHttpsOnLink =
      !!link &&
      typeof link === "string" &&
      (link.includes("https://") || link.includes("http://"));
    const updatedLinkImg = hasHttpsOnLink ? link : "";
    const formatedLink =
      !hasHttpsOnLink && hasLink ? `${urlIngWeb}${link}` : link;

    const isImage = typename.includes("image");
    if (isImage && hasLink) {
      return (
        <img
          style={{ maxWidth: "87%", objectFit: "cover", cursor: "pointer" }}
          src={formatedLink}
          onClick={() => {
            setLinkImg(updatedLinkImg);
            setGaleryContent([
              { file: { path_arquivos: link, name: "imagem" } },
            ]);
            setOpenGallery(true);
          }}
        />
      );
    }

    const isAudio =
      [4, 6, 15, 17, 21, 25, 26, 27, 28, 39, 40].includes(mimetypeid) ||
      typename === "audio" ||
      typename === "voice";
    if (isAudio && hasLink) {
      return <Audio audio={true} link={formatedLink} />;
    }

    const isVideo = mimetypeid === 16;
    if (isVideo && hasLink) {
      return (
        <div>
          <video controls width={"100%"}>
            <source src={formatedLink} type="video/mp4" />
          </video>
        </div>
      );
    }

    const isPdf = mimetypeid === 5;
    if (isPdf) {
      return renderFileLink(<PdfIcon />, formatedLink, fileName);
    }

    const isZip = mimetypeid === 7;
    if (isZip) {
      return renderFileLink(<ZipIcon />, formatedLink, fileName);
    }

    const isXls = mimetypeid === 8;
    if (isXls) {
      return renderFileLink(<XlsIcon />, formatedLink, fileName);
    }

    const isXlsx = mimetypeid === 9;
    if (isXlsx) {
      return renderFileLink(<XlsxIcon />, formatedLink, fileName);
    }

    const isDocX = mimetypeid === 10;
    if (isDocX) {
      return renderFileLink(<DocxIcon />, formatedLink, fileName);
    }

    const isDoc = mimetypeid === 11;
    if (isDoc) {
      return renderFileLink(<DocIcon />, formatedLink, fileName);
    }

    const isPpt = mimetypeid === 12;
    if (isPpt) {
      return renderFileLink(<PptIcon />, formatedLink, fileName);
    }

    const isPptx = mimetypeid === 13;
    if (isPptx) {
      return renderFileLink(<PptxIcon />, formatedLink, fileName);
    }

    const isTxt = mimetypeid === 14;
    if (isTxt) {
      return renderFileLink(<TxtIcon />, formatedLink, fileName);
    }

    return null;
  };

  const renderContent = (page) => {
    const isPageStepOne = page === 0;
    if (isPageStepOne) {
      const renderStepOneContent = () => {
        if (isLoadingStepOne) {
          return (
            <div>
              <SkeletonLoading numberOfItems={10} />
            </div>
          );
        }

        if (!hasFilteredDataStepOne) {
          return (
            <div className="campaign-side-content__list__empty-state-container">
              <EmptyState />
            </div>
          );
        }

        return filteredDataStepOne.map((campaign, index) => {
          return (
            <li
              key={`campaign-side-content-list-item--${index}`}
              className="campaign-side-content__list__item item-with-border"
              onClick={() => {
                setInputValue("");
                setTextToFilterStepOne("");
                //setPageSelected(1);
                listContentStepTwoDirect(campaign.id_categoria);
              }}
            >
              <div className="campaign-side-content__list__item__icon-container">
                <CampaignIcon />
              </div>
              <p className="campaign-side-content__list__item__title">
                {campaign.title}
              </p>
            </li>
          );
        });
      };
      return (
        <div className="campaign-side-content">
          <div className="campaign-side-content__search-container">
            <div className="full-search">
              <div className="full-search_container">
                <input
                  type="text"
                  name="client-search"
                  id="client-search"
                  value={inputValue}
                  onChange={(event) => {
                    setInputValue(event.target.value);
                    if (event.target.value === "") {
                      setTextToFilterStepOne("");
                    }
                  }}
                  onKeyDown={(event) => {
                    const isEnterPressed = event.key === "Enter";
                    if (isEnterPressed) {
                      setTextToFilterStepOne(inputValue);
                    }
                  }}
                  placeholder="Pesquisar"
                />
                <button
                  onClick={() => {
                    setTextToFilterStepOne(inputValue);
                  }}
                  type="submit"
                  className="full-search__btn"
                >
                  <Search />
                </button>
              </div>
            </div>
          </div>
          <ul className="campaign-side-content__list">
            {renderStepOneContent()}
          </ul>
        </div>
      );
    }

    const isPageStepTwo = page === 1;
    if (isPageStepTwo) {
      const renderStepTwoContent = () => {
        if (isLoadingStepTwo) {
          return (
            <div>
              <SkeletonLoading numberOfItems={10} />
            </div>
          );
        }

        if (!hasFilteredDataStepTwo) {
          return (
            <div className="campaign-side-content__list__empty-state-container">
              <EmptyState />
            </div>
          );
        }

        return filteredDataStepTwo.map((campaign, index) => {
          return (
            <li
              key={`campaign-side-content-list-item--${index}`}
              className="campaign-side-content__list__item item-with-border"
              onClick={() => {
                setInputValueStepTwo("");
                setTextToFilterStepTwo("");
                //setPageSelected(2);
                listContentStepThreeDirect(campaign.id_secao);
              }}
            >
              <div className="campaign-side-content__list__item__icon-container">
                <CampaignIcon />
              </div>
              <p className="campaign-side-content__list__item__title">
                {campaign.title}
              </p>
            </li>
          );
        });
      };
      return (
        <div className="campaign-side-content campaign-side-content-step-two">
          <div className="campaign-side-content__search-container">
            <div className="full-search">
              <div className="full-search_container">
                <input
                  type="text"
                  name="client-search"
                  id="client-search"
                  value={inputValueStepTwo}
                  onChange={(event) => {
                    setInputValueStepTwo(event.target.value);
                    if (event.target.value === "") {
                      setTextToFilterStepTwo("");
                    }
                  }}
                  onKeyDown={(event) => {
                    const isEnterPressed = event.key === "Enter";
                    if (isEnterPressed) {
                      setTextToFilterStepTwo(inputValueStepTwo);
                    }
                  }}
                  placeholder="Pesquisar"
                />
                <button
                  onClick={() => {
                    setTextToFilterStepTwo(inputValueStepTwo);
                  }}
                  type="submit"
                  className="full-search__btn"
                >
                  <Search />
                </button>
              </div>
            </div>
          </div>
          <div className="campaign-side-content__links">
            <Tooltip title="Início" placement="top">
              <span
                className="campaign-side-content__links__item active"
                onClick={() => {
                  setInputValueStepTwo("");
                  setTextToFilterStepTwo("");
                  setPageSelected(0);
                  clearFilesToNotSend();
                  clearFilesToSend();
                }}
              >
                Início
              </span>
            </Tooltip>
            {titleOfStepTwo && (
              <Tooltip title={titleOfStepTwo.name} placement="top">
                <span
                  className={`campaign-side-content__links__item`}
                >{` / ${titleOfStepTwo.name}`}</span>
              </Tooltip>
            )}
          </div>
          {/*<div className="campaign-side-content-step-two__header">
<button
className="campaign-side-content-step-two__header__btn"
onClick={() => {
setTextToFilterStepTwo("");
setInputValueStepTwo("");
setPageSelected(0);
}}
>
<ArrowIcon />
</button>
</div>*/}
          <ul className="campaign-side-content__list">
            {renderStepTwoContent()}
          </ul>
        </div>
      );
    }

    const isPageStepThree = page === 2;
    if (isPageStepThree) {
      const renderStepThreeContent = () => {
        if (isLoadingStepThree) {
          return (
            <div>
              <SkeletonLoading numberOfItems={10} />
            </div>
          );
        }

        if (!hasFilteredDataStepThree) {
          return (
            <div className="campaign-side-content__list__empty-state-container">
              <EmptyState />
            </div>
          );
        }

        return filteredDataStepThree.map((campaign, index) => {
          return (
            <li
              key={`campaign-side-content-list-item--${index}`}
              className="campaign-side-content__list__item"
              onClick={() => {
                setInputValueStepThree("");
                setTextToFilterStepThree("");
                setPageSelected(3);
                clearFilesToNotSend();
                clearFilesToSend();
                listContentStepFour(campaign.id_assunto);
              }}
            >
              <div className="campaign-side-content__list__item__icon-container">
                <CampaignIcon />
              </div>
              <p className="campaign-side-content__list__item__title">
                {campaign.title}
              </p>
            </li>
          );
        });
      };

      return (
        <div className="campaign-side-content campaign-side-content-step-two">
          <div className="campaign-side-content__search-container">
            <div className="full-search">
              <div className="full-search_container">
                <input
                  type="text"
                  name="client-search"
                  id="client-search"
                  value={inputValueStepThree}
                  onChange={(event) => {
                    setInputValueStepThree(event.target.value);
                    if (event.target.value === "") {
                      setTextToFilterStepThree("");
                    }
                  }}
                  onKeyDown={(event) => {
                    const isEnterPressed = event.key === "Enter";
                    if (isEnterPressed) {
                      setTextToFilterStepThree(inputValueStepThree);
                    }
                  }}
                  placeholder="Pesquisar"
                />
                <button
                  onClick={() => {
                    setTextToFilterStepThree(inputValueStepThree);
                  }}
                  type="submit"
                  className="full-search__btn"
                >
                  <Search />
                </button>
              </div>
            </div>
          </div>
          <div className="campaign-side-content__links">
            <Tooltip title="Início" placement="top">
              <span
                className="campaign-side-content__links__item active"
                onClick={() => {
                  setInputValueStepThree("");
                  setTextToFilterStepThree("");
                  setPageSelected(0);
                  clearFilesToNotSend();
                  clearFilesToSend();
                }}
              >
                Início
              </span>
            </Tooltip>
            {titleOfStepTwo && (
              <Tooltip title={titleOfStepTwo.name} placement="top">
                <span
                  className={`campaign-side-content__links__item active`}
                  onClick={() => {
                    setInputValueStepThree("");
                    setTextToFilterStepThree("");
                    setPageSelected(1);
                    clearFilesToNotSend();
                    clearFilesToSend();
                  }}
                >{` / ${titleOfStepTwo.name}`}</span>
              </Tooltip>
            )}
            {titleOfStepThree && (
              <Tooltip title={titleOfStepThree.name} placement="top">
                <span
                  className={`campaign-side-content__links__item`}
                >{` / ${titleOfStepThree.name}`}</span>
              </Tooltip>
            )}
          </div>
          {/*<div className="campaign-side-content-step-two__header">
<button
className="campaign-side-content-step-two__header__btn"
onClick={() => {
setTextToFilterStepThree("");
setInputValueStepThree("");
setPageSelected(1);
}}
>
<ArrowIcon />
</button>
</div>*/}
          <ul className="campaign-side-content__list">
            {renderStepThreeContent()}
          </ul>
        </div>
      );
    }

    const isPageStepFour = page === 3;
    if (isPageStepFour) {
      const renderStepFourContent = () => {
        if (isLoadingStepFour) {
          return <SkeletonLoading numberOfItems={10} />;
        }

        if (!hasFilteredDataStepFour) {
          return (
            <div className="campaign-side-content__list__empty-state-container">
              <EmptyState />
            </div>
          );
        }

        return filteredDataStepFour.map((campaign, index) => {
          const descContent = campaign.desc_conteudo;
          const hasDescContent = !!descContent;
          const hasLink =
            !!campaign.caminho_arquivo &&
            campaign.caminho_arquivo !== "null" &&
            campaign.caminho_arquivo !== "undefined" &&
            campaign.caminho_arquivo !== "null.undefined" &&
            campaign.caminho_arquivo !== ".undefined" &&
            campaign.typename !== "message";

          if (hasLink && hasDescContent) {
            return (
              <div
                key={index}
                style={{ display: "flex", alignItems: "flex-start" }}
              >
                {isToShare && (
                  <CustomCheckbox
                    checked={
                      connection_platform.allowSendingMultipleItemInCampaing
                        ? !filesToNotSend.includes(campaign.id_conteudo)
                        : fileToSend === campaign.id_conteudo
                    }
                    onChange={(e) => {
                      if (
                        connection_platform.allowSendingMultipleItemInCampaing
                      ) {
                        handleCheckToRemoveFiles(e, campaign.id_conteudo);
                      } else {
                        handleCheckToAddFiles(e, campaign.id_conteudo);
                      }
                    }}
                    model={
                      connection_platform.allowSendingMultipleItemInCampaing
                        ? "checkbox"
                        : "radio"
                    }
                  />
                )}
                <div>
                  {treatMimetype(
                    campaign.mimetypeid,
                    campaign.typename,
                    campaign.caminho_arquivo,
                    campaign.caminho_arquivo
                  )}
                  <HtmlContent htmlString={descContent} />
                </div>
              </div>
            );
          }

          if (hasLink && !hasDescContent) {
            return (
              <div
                key={index}
                style={{ display: "flex", alignItems: "flex-start" }}
              >
                {isToShare && (
                  <CustomCheckbox
                    checked={
                      connection_platform.allowSendingMultipleItemInCampaing
                        ? !filesToNotSend.includes(campaign.id_conteudo)
                        : fileToSend === campaign.id_conteudo
                    }
                    onChange={(e) => {
                      if (
                        connection_platform.allowSendingMultipleItemInCampaing
                      ) {
                        handleCheckToRemoveFiles(e, campaign.id_conteudo);
                      } else {
                        handleCheckToAddFiles(e, campaign.id_conteudo);
                      }
                    }}
                    model={
                      connection_platform.allowSendingMultipleItemInCampaing
                        ? "checkbox"
                        : "radio"
                    }
                  />
                )}
                {treatMimetype(
                  campaign.mimetypeid,
                  campaign.typename,
                  campaign.caminho_arquivo,
                  campaign.caminho_arquivo
                )}
              </div>
            );
          }

          if (!hasLink && hasDescContent) {
            return (
              <div
                key={index}
                style={{ display: "flex", alignItems: "flex-start" }}
              >
                {isToShare && (
                  <CustomCheckbox
                    checked={
                      connection_platform.allowSendingMultipleItemInCampaing
                        ? !filesToNotSend.includes(campaign.id_conteudo)
                        : fileToSend === campaign.id_conteudo
                    }
                    onChange={(e) => {
                      if (
                        connection_platform.allowSendingMultipleItemInCampaing
                      ) {
                        handleCheckToRemoveFiles(e, campaign.id_conteudo);
                      } else {
                        handleCheckToAddFiles(e, campaign.id_conteudo);
                      }
                    }}
                    model={
                      connection_platform.allowSendingMultipleItemInCampaing
                        ? "checkbox"
                        : "radio"
                    }
                  />
                )}
                <div key={index}>
                  <HtmlContent htmlString={descContent} />
                </div>
              </div>
            );
          }

          return null;
        });
      };

      return (
        <div className="campaign-side-content campaign-side-content-step-two campaign-side-content-step-four">
          {/*<div className="campaign-side-content__search-container">
<div className="full-search">
<div className="full-search_container">
<input
type="text"
name="client-search"
id="client-search"
value={inputValueStepFour}
onChange={(event) => {
setInputValueStepFour(event.target.value);
if (event.target.value === "") {
setTextToFilterStepFour("");
}
}}
onKeyDown={(event) => {
const isEnterPressed = event.key === "Enter";
if (isEnterPressed) {
setTextToFilterStepFour(inputValueStepFour);
}
}}
placeholder="Pesquisar"
/>
<button
onClick={() => {
setTextToFilterStepFour(inputValueStepFour);
}}
type="submit"
className="full-search__btn"
>
<Search />
</button>
</div>
</div>
</div> */}
          <div className="campaign-side-content__links step-four-links">
            <Tooltip title="Início" placement="top">
              <span
                className="campaign-side-content__links__item active"
                onClick={() => {
                  setInputValueStepFour("");
                  setTextToFilterStepFour("");
                  setPageSelected(0);
                  clearFilesToNotSend();
                  clearFilesToSend();
                }}
              >
                Início
              </span>
            </Tooltip>
            {titleOfStepTwo && (
              <Tooltip title={titleOfStepTwo.name} placement="top">
                <span
                  className={`campaign-side-content__links__item active`}
                  onClick={() => {
                    setInputValueStepFour("");
                    setTextToFilterStepFour("");
                    setPageSelected(1);
                    clearFilesToNotSend();
                    clearFilesToSend();
                  }}
                >{` / ${titleOfStepTwo.name}`}</span>
              </Tooltip>
            )}
            {titleOfStepThree && (
              <Tooltip title={titleOfStepThree.name} placement="top">
                <span
                  className={`campaign-side-content__links__item active`}
                  onClick={() => {
                    setInputValueStepFour("");
                    setTextToFilterStepFour("");
                    setPageSelected(2);
                    clearFilesToNotSend();
                    clearFilesToSend();
                  }}
                >{` / ${titleOfStepThree.name}`}</span>
              </Tooltip>
            )}
            {titleOfStepFour && (
              <Tooltip title={titleOfStepFour.name} placement="top">
                <span
                  className={`campaign-side-content__links__item`}
                >{` / ${titleOfStepFour.name}`}</span>
              </Tooltip>
            )}
          </div>
          <div className="campaign-side-content-step-two__header campaign-side-content-step-four__header">
            <button
              className="campaign-side-content-step-two__header__btn"
              onClick={() => {
                setTextToFilterStepFour("");
                setInputValueStepFour("");
                setPageSelected(2);
                clearFilesToNotSend();
                clearFilesToSend();
              }}
            >
              <ArrowIcon />
            </button>
          </div>
          <ul className="campaign-side-content__list campaign-side-content__list-step-four">
            {renderStepFourContent()}
          </ul>
          {isToShare && (
            <div className="campaign-side-content-step-four__button-container">
              <button
                disabled={disabledButton}
                className={`campaign-side-content-intern__content__button ${
                  disabledButton ? "disabled" : ""
                }`}
                onClick={() => {
                  try {
                    let filteredDataStepFourWithFilesSelecteds =
                      filteredDataStepFour;
                    if (
                      Array.isArray(filteredDataStepFour) &&
                      Array.isArray(filesToNotSend)
                    ) {
                      if (
                        connection_platform.allowSendingMultipleItemInCampaing
                      ) {
                        filteredDataStepFourWithFilesSelecteds =
                          filteredDataStepFourWithFilesSelecteds.filter(
                            (data) => !filesToNotSend.includes(data.id_conteudo)
                          );
                      } else {
                        filteredDataStepFourWithFilesSelecteds =
                          filteredDataStepFourWithFilesSelecteds.filter(
                            (data) => fileToSend === data.id_conteudo
                          );
                      }
                    }
                    dispatch(
                      changeMessageFromHelpSideContent(
                        contactId.idatendimento,
                        filteredDataStepFourWithFilesSelecteds,
                        contactId,
                        infoUsers
                      )
                    );
                  } catch (error) {
                    toast.error("Erro ao compartilhar!");
                    console.log("Erro ao compartilhar", { error });
                  }
                }}
              >
                {isSendingMessage ? (
                  <CircularProgress size={24} />
                ) : (
                  <ShareIcon />
                )}
                <span>Compartilhar</span>
              </button>
            </div>
          )}
        </div>
      );
    }
  };

  useEffect(() => {
    const listContentStepOneDirect = async () => {
      setIsLoadingStepOne(true);
      setIsLoadingStepTwo(true);
      setIsLoadingStepThree(true);
      setIsLoadingStepFour(true);
      let updatedDataStepOne = [];
      const response = await listHelpSideContentStepOne(
        1,
        ingFaqConditions.url
      );
      const hasResponse = !!response && response.status === 200;
      if (hasResponse) {
        const data = response.data;
        const hasData = !!data && Array.isArray(data) && data.length > 0;
        if (hasData) {
          updatedDataStepOne = data.map((datum) => {
            datum.title = datum.desc_categoria;
            return datum;
          });
        }
      }

      setDataStepOne(updatedDataStepOne);

      const hasOnlyOneStepOne = updatedDataStepOne.length === 1;
      if (hasOnlyOneStepOne) {
        let updatedDataStepTwo = [];
        let updatedTitleOfStepTwo = null;
        const idcategoria = updatedDataStepOne[0].id_categoria;
        const response = await listHelpSideContentStepTwo(
          idcategoria,
          1,
          ingFaqConditions.url
        );
        const hasResponse = !!response && response.status === 200;
        if (hasResponse) {
          const data = response.data;
          const hasData = !!data && Array.isArray(data) && data.length > 0;
          if (hasData) {
            updatedDataStepTwo = data.map((datum) => {
              datum.title = datum.desc_secao;
              return datum;
            });
            updatedTitleOfStepTwo = {
              name: data[0].desc_categoria,
              id: data[0].id_categoria,
              active: false,
            };
          }
        }
        setTitleOfStepTwo(updatedTitleOfStepTwo);
        setDataStepTwo(updatedDataStepTwo);

        const hasOnlyOneDataInStepTwo = updatedDataStepTwo.length === 1;
        if (hasOnlyOneDataInStepTwo) {
          let updatedDataStepThree = [];
          let updatedTitleOfStepThree = null;
          const id_secao = updatedDataStepTwo[0].id_secao;

          const response = await listHelpSideContentStepThree(
            id_secao,
            1,
            ingFaqConditions.url
          );
          const hasResponse = !!response;
          if (hasResponse) {
            const data = response.data;
            const hasData = !!data && data.length > 0;
            if (hasData) {
              updatedDataStepThree = data.map((datum) => {
                datum.title = datum.desc_assunto;
                return datum;
              });
              updatedTitleOfStepThree = {
                name: data[0].desc_secao,
                id: data[0].id_secao,
                active: false,
              };
            }
          }
          setTitleOfStepThree(updatedTitleOfStepThree);
          setDataStepThree(updatedDataStepThree);

          const hasOnlyOneStepThree = updatedDataStepThree.length === 1;
          if (hasOnlyOneStepThree) {
            let updatedDataStepFour = [];
            let updatedTitleOfStepFour = null;
            const id_assunto = updatedDataStepThree[0].id_assunto;

            const response = await listHelpSideContentStepFour(
              id_assunto,
              1,
              ingFaqConditions.url
            );
            const hasResponse = !!response && response.status === 200;
            if (hasResponse) {
              const data = response.data;
              const hasData = !!data && data.length > 0;
              if (hasData) {
                updatedDataStepFour = data.map((datum) => {
                  const descContent = datum.desc_conteudo;
                  const hasDescContent = !!descContent;
                  const hasLink =
                    !!datum.caminho_arquivo &&
                    datum.caminho_arquivo !== "null" &&
                    datum.caminho_arquivo !== "undefined" &&
                    datum.caminho_arquivo !== "null.undefined" &&
                    datum.caminho_arquivo !== ".undefined" &&
                    datum.typename !== "message";

                  if (hasDescContent && !hasLink) {
                    datum.typeOfContent = "onlyText";
                    datum.linkOfFile = "";
                    datum.treatedText = datum.desc_conteudo
                      .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                      .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                      .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                      .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                      .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                      .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                      .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                      .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                      .replace(/&amp;/g, "&") // Substitui "&" codificados
                      .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                      .trim();
                  }

                  if (hasDescContent && hasLink) {
                    datum.typeOfContent = "textAndFile";
                    datum.linkOfFile = datum.caminho_arquivo;
                    datum.treatedText = datum.desc_conteudo
                      .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                      .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                      .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                      .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                      .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                      .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                      .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                      .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                      .replace(/&amp;/g, "&") // Substitui "&" codificados
                      .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                      .trim();
                  }

                  if (!hasDescContent && hasLink) {
                    datum.typeOfContent = "onlyFile";
                    datum.linkOfFile = datum.caminho_arquivo;
                    datum.treatedText = "";
                  }

                  const hasInternalLink =
                    hasDescContent &&
                    typeof datum.desc_conteudo === "string" &&
                    datum.desc_conteudo.includes("</a>") &&
                    Boolean(datum.desc_conteudo.match(/href="([^"]+)"/));
                  if (hasInternalLink) {
                    const hrefMatch =
                      datum.desc_conteudo.match(/href="([^"]+)"/);
                    datum.typeOfContent = "externalLink";
                    datum.linkOfFile = "";
                    datum.treatedText = datum.desc_conteudo
                      .replace(/<a\b[^>]*href="([^"]*)"[^>]*>.*?<\/a>/gi, "$1")
                      .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                      .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                      .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                      .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                      .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                      .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                      .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                      .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                      .replace(/&amp;/g, "&") // Substitui "&" codificados
                      .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                      .trim();
                  }

                  const hasYoutubeLink =
                    hasDescContent &&
                    typeof datum.desc_conteudo === "string" &&
                    datum.desc_conteudo.includes("</iframe>") &&
                    Boolean(datum.desc_conteudo.match(/src="([^"]+)"/));

                  if (hasYoutubeLink) {
                    const hrefMatch =
                      datum.desc_conteudo.match(/src="([^"]+)"/);
                    datum.typeOfContent = "externalLink";
                    datum.linkOfFile = "";
                    datum.treatedText = datum.desc_conteudo
                      .replace(
                        /<iframe\b[^>]*src="([^"]*)"[^>]*>.*?<\/iframe>/gi,
                        "$1"
                      )
                      .replace(/<strong[^>]*>(.*?)<\/strong>/gi, "*$1*") // Coloca o conteúdo de <strong> em negrito
                      .replace(/<\/?(h[1-6]|p|div)[^>]*>/gi, "\n\n") // Adiciona duas quebras de linha para blocos
                      .replace(/<br\s*\/?>/gi, "\n") // Converte <br> para uma quebra de linha simples
                      .replace(/<ul[^>]*>/gi, "\n") // Adiciona quebra de linha antes da lista
                      .replace(/<\/ul>/gi, "\n") // Adiciona quebra de linha depois da lista
                      .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n") // Converte <li> em um item de lista
                      .replace(/<[^>]+>/g, "") // Remove qualquer outra tag HTML
                      .replace(/&nbsp;/g, " ") // Substitui espaços não quebráveis
                      .replace(/&amp;/g, "&") // Substitui "&" codificados
                      .replace(/\n{3,}/g, "\n\n") // Mantém no máximo duas quebras de linha
                      .trim();
                  }

                  if (
                    !hasDescContent &&
                    !hasLink &&
                    !hasInternalLink &&
                    !hasYoutubeLink
                  ) {
                    datum.typeOfContent = "";
                    datum.linkOfFile = "";
                    datum.treatedText = "";
                  }

                  datum.title = datum.desc_assunto;
                  return datum;
                });

                updatedTitleOfStepFour = {
                  name: data[0].desc_assunto,
                  id: data[0].id_assunto,
                  active: false,
                };
              }
            }
            setTitleOfStepFour(updatedTitleOfStepFour);
            setDataStepFour(updatedDataStepFour);

            setPageSelected(3);
            clearFilesToNotSend();
            clearFilesToSend();
          } else {
            setPageSelected(2);
            clearFilesToNotSend();
            clearFilesToSend();
          }
        } else {
          setPageSelected(1);
          clearFilesToNotSend();
          clearFilesToSend();
        }
      }

      setIsLoadingStepOne(false);
      setIsLoadingStepTwo(false);
      setIsLoadingStepThree(false);
      setIsLoadingStepFour(false);
    };

    const listContentStepOne = async () => {
      setIsLoadingStepOne(true);
      let updatedDataStepOne = [];
      const response = await listHelpSideContentStepOne(
        1,
        ingFaqConditions.url
      );
      const hasResponse = !!response && response.status === 200;
      if (hasResponse) {
        const data = response.data;
        const hasData = !!data && Array.isArray(data) && data.length > 0;
        if (hasData) {
          updatedDataStepOne = data.map((datum) => {
            datum.title = datum.desc_categoria;
            return datum;
          });
        }
      }

      setDataStepOne(updatedDataStepOne);
      setIsLoadingStepOne(false);
    };

    listContentStepOneDirect();

    return () => {
      dispatch(changeIsLoadingSideContent(false));
    };
  }, [ingFaqConditions]);

  return (
    <div className="campaign-side-content-container">
      {renderContent(pageSelected)}
      {
        <ModalImage
          openGallery={openGallery}
          setOpenGallery={setOpenGallery}
          content={galeryContent}
          linkImg={linkImg}
        />
      }
    </div>
  );
};

export default React.memo(HelpSideContent);
